import type {
  BlockConfigBase,
  BlocksConfigData,
  JSONSchema,
} from '@plone/types';
import { defineMessages, type IntlShape } from 'react-intl';

import addBlocksFullWidth from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addBlocksFullWidth';
import addBlockLines from '@redturtle/qubicaamf-theme/components/Blocks/extenders/addBlockLines';

const messages = defineMessages({
  headline: {
    id: 'Headline',
    defaultMessage: 'Headline',
  },
  grid: {
    id: 'expandableGrid',
    defaultMessage: 'Expandable Cards',
  },
});

export interface ExpandableGridData extends JSONSchema {
  '@type': 'expandableGrid';
  headline?: string;
  columns?: Array<{
    blocks: object;
    blocks_layout: {
      items: string[];
    };
  }>;
}

export const ExpandableGridBlockSchema = ({
  data,
  intl,
}: {
  data: ExpandableGridData;
  intl: IntlShape;
}) => {
  const schema = {
    title: intl.formatMessage(messages.grid),
    block: 'expandableGrid',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['headline'],
      },
    ],

    properties: {
      headline: {
        title: intl.formatMessage(messages.headline),
      },
    },
    required: [],
  };

  addBlocksFullWidth({ schema, formData: data, intl });
  addBlockLines({ schema, formData: data, intl });
  return schema;
};

export interface ExpandableGridConfig
  extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof ExpandableGridBlockSchema;

  allowedBlocks: (keyof BlocksConfigData)[];
}
